import { createContext } from 'react';
export var DEFAULT_VALUE = {
  containerRef: {},
  disabled: false,
  onKeyDown: null,
  overflowRef: {},
  stickyColumns: 1,
  tableRef: {},
  width: '100%'
};
export default createContext(DEFAULT_VALUE);